export const PROMPT_PAYMENT = "promptPayment";
export const FIDELIZATIONS = "fidelizations";
export const POINTS = "points";
export const INSTALLMENTS = "installments";
export const INSTALLMENTS_NPLAY = "installmentsNPlay";
export const INSTALLMENTS_MOBILEVOICE = "installmentsMobileVoice";
export const INSTALLMENTS_OTHERS = "installmentsOthers";
export const ALL_FILTER = "todos";
